import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { BefehlFormAuftrag, BefehlFormField } from '../Generic'
import { TextArea } from '../../form'
import { DEFAULT_AUFTRAG_95_95 } from './schema/befehl95-form.schema'

export interface Auftrag95_95FormProps {
  fieldNamePrefix: string
  readOnly: boolean
  'data-testid': string
  activateEmptyFieldWarnings?: boolean
}

export default function Auftrag95_95Form({
  fieldNamePrefix,
  readOnly,
  'data-testid': testId,
  activateEmptyFieldWarnings = false
}: Readonly<Auftrag95_95FormProps>) {
  const formMethods = useFormContext()
  const { control, formState, resetField } = formMethods
  const { errors } = formState
  const { t } = useTranslation('ui-befehle')

  const auftragFieldName = `${fieldNamePrefix}.enabled`
  const freitextFieldName = `${fieldNamePrefix}.freitext`

  const isAuftragEnabled = formMethods.watch(auftragFieldName)

  return (
    <BefehlFormAuftrag
      auftragKennung={`95.95`}
      displayKennung={`95.95`}
      fieldName={auftragFieldName}
      control={control}
      readOnly={readOnly}
      testId={testId}
      onChange={(checked) => {
        if (!checked) {
          resetField('auftrag_95_95', {
            defaultValue: DEFAULT_AUFTRAG_95_95
          })
        }
      }}
    >
      <span data-testid={`${testId}-text`}>{t('auftraege.95_95')}</span>
      <div className="flex-1">
        <div className="flex flex-col">
          <BefehlFormField
            name={freitextFieldName}
            control={control}
            label={``}
            readOnly={readOnly}
            disabled={!isAuftragEnabled}
            activateEmptyWarning={activateEmptyFieldWarnings}
            className="w-full"
            data-testid={`${testId}-feld-95-96`}
            isTextArea={true}
            render={({
              field: freitextField,
              isDisabled: isFreitextDisabled,
              isReadOnly
            }) => (
              <TextArea
                {...freitextField}
                label={''}
                rows={4}
                disabled={isFreitextDisabled}
                readOnly={isReadOnly}
                errors={errors}
                className="w-full"
                data-testid={`${testId}-feld-95-96-inner`}
              />
            )}
          />
          <label
            data-testid={`${testId}-feld-95-96-label`}
            className={isAuftragEnabled ? '' : 'text-gray-500 opacity-60'}
          >
            <span>95.96</span>{' '}
            <span className="italic">[{t('auftraege.x_95.x_96.label')}]</span>
          </label>
        </div>
      </div>
    </BefehlFormAuftrag>
  )
}
